(function () {
  function initDescriptionToggle(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var wrappers = root.querySelectorAll
      ? root.querySelectorAll('.product__description-wrapper')
      : [];

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.descriptionToggleInit === 'true') return;
      wrapper.dataset.descriptionToggleInit = 'true';

      var desc = wrapper.querySelector('.product__description');
      var btn = wrapper.querySelector('.product__description-toggle');
      if (!desc || !btn) return;

      var texts = btn.querySelectorAll('.product__description-toggle-text');
      var showMore = texts[0];
      var showLess = texts[1];

      function setExpanded(expanded) {
        if (expanded) {
          desc.classList.add('active');
          if (showMore) showMore.classList.remove('active');
          if (showLess) showLess.classList.add('active');
          btn.setAttribute('aria-expanded', 'true');
        } else {
          desc.classList.remove('active');
          if (showMore) showMore.classList.add('active');
          if (showLess) showLess.classList.remove('active');
          btn.setAttribute('aria-expanded', 'false');
        }
      }

      desc.classList.remove('active');
      void desc.offsetHeight;

      var maxHeightPx = parseFloat(window.getComputedStyle(desc).maxHeight, 10);
      if (!maxHeightPx || isNaN(maxHeightPx)) {
        var rem =
          parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
        maxHeightPx = 10 * rem;
      }

      var needsToggle = desc.scrollHeight > maxHeightPx + 1;

      if (!needsToggle) {
        desc.classList.add('active');
        btn.hidden = true;
        return;
      }

      btn.hidden = false;
      setExpanded(false);

      btn.addEventListener('click', function () {
        setExpanded(!desc.classList.contains('active'));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDescriptionToggle();
    });
  } else {
    initDescriptionToggle();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll('.product__description-wrapper').forEach(function (w) {
        delete w.dataset.descriptionToggleInit;
      });
      initDescriptionToggle(event.target);
    }
  });
})();
